import { Register } from "~/components";

export default () => (
	<div class="rias-content col-span-full">
		<h1 class="headline-lg">Register for Membership</h1>

		<p>This is the first step in becoming an Approved Certifier of Design.</p>

		<p>RIAS-regs currently approves:</p>
		<ul>
			<li>Certifiers of Design (Section 6 – Energy) Domestic of the Scottish Building Standards.</li>
			<li>Certifiers of Design (Section 6 – Energy) Non-domestic of the Scottish Building Standards, both standard and advanced.</li>
		</ul>

		<p>We also offer the option of CPD-only membership, with a reduced rate for RIAS members.</p>

		<p>Registering your interest consists of 3 steps:</p>

		<ol>
			<li>First of all we will ask you to provide you name, contact and company details.</li>
			<li>RIAS-regs will then check and verify your registration details, this may take up to a week to complete.</li>
			<li>Once your details have been verified, you will be informed by email that your interest has been registered. On any future visits to <a href="https://rias-regs.co.uk">rias-regs.co.uk</a> you will be able access the site via your email address and our email one-time code system which negates the need for a password.</li>
		</ol>

		<p>If for any reason your details cannot be verified you will be asked to confirm them again or you may receive a telephone call from RIAS-regs to discuss the problem.</p>

		<p>Registration will re-open shortly.</p>
		{/*		<Register />*/}
	</div>
);
